
export const getWindowWidth = () => window.innerWidth 
	|| document.documentElement.clientWidth 
	|| document.body.clientWidth

export const getWindowHeight = () => window.innerHeight 
	|| document.documentElement.clientHeight 
	|| document.body.clientHeight




// WEBPACK FOOTER //
// ./src/utils.js